import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { LoginBackground } from "@/assets/images/login-background";
import { LoginForm } from "@/components/pages/login/login-form";
import { useAuthStore } from "@/stores/auth-store";

export const LoginPage = () => {
  const { token, user, me } = useAuthStore();

  useEffect(() => {
    if (token && !user) me();
  }, [token, user, me]);

  if (token && user) return <Navigate to="/dashboard" replace />;

  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <LoginBackground />
      <div className="z-10 w-full max-w-[350px] -mt-20 md:mt-0">
        <LoginForm />
      </div>
    </div>
  );
};
